import React, { useMemo } from 'react';
import { keyBy } from 'lodash/fp';
import MultiSelect from 'components/shared/index/filters/multi_select';
import { useFilterControl } from 'components/shared/FilterContext';
import FilterToggleButton from '../shared/FilterToggleButton';

const Groups = ({ groups }) => {
  const groupsById = useMemo(() => keyBy('id', groups), [groups]);
  const groupsFilter = useMemo(
    () => ({
      name: 'groups',
      defaultState: [],
      removeSelected(id, selectedIds) {
        return selectedIds.filter(selectedId => selectedId !== id);
      },
      renderSelected: id => groupsById[id].name,
    }),
    [groupsById],
  );

  const [selectedIds, setSelectedIds] = useFilterControl(groupsFilter);

  return (
    <MultiSelect
      wrapperClassName="pos-r d-ib"
      popoverClassName=""
      sort={{ key: 'name', descending: false }}
      data={groupsById}
      selected={selectedIds}
      applyCallback={setSelectedIds}
      renderToggle={({ toggle }) => (
        <FilterToggleButton onClick={toggle} disabled={groups.length === 0}>
          {groups.length === 0
            ? t('insights.filters.no_groups')
            : t('insights.filters.filter_by_group')}
        </FilterToggleButton>
      )}
    />
  );
};

export default Groups;
